/** Unread indicators — a count pill for nav items, a dot for list rows. */

export function UnreadBadge({ count, testid }) {
  if (!count) return null;
  return (
    <span
      data-testid={testid}
      className="ml-auto shrink-0 inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5
                 rounded-full text-[10px] font-bold tabular-nums"
      style={{ background: "#C6A15B", color: "#201D17" }}
    >
      {count > 9 ? "9+" : count}
    </span>
  );
}

export function UnreadDot({ count, testid, label = "new reply" }) {
  if (!count) return null;
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-widest"
      style={{ background: "rgba(198,161,91,0.18)", color: "#8A6B25" }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: "#C6A15B" }} />
      {count} {label}{count > 1 ? "s" : ""}
    </span>
  );
}

export default UnreadBadge;
